// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6212765c","75":"252f3668","116":"a002e301"}[chunkId] + ".chunk.js";
};